// extracted by mini-css-extract-plugin
export var backupIcon = "_nw-1";
export var image = "_nw-0";